import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Crown } from "lucide-react";
import api from "../lib/apiClient";
import { useAuth } from "../context/AuthContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); await refresh(); return; }
        if (data.status === "expired" || tries > 8) { setStatus("error"); return; }
      } catch { setStatus("error"); return; }
      tries += 1;
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId, refresh]);

  return (
    <div className="max-w-md mx-auto text-center py-20 fade-up">
      {status === "checking" && (<><div className="animate-pulse w-16 h-16 rounded-full bg-brand-light mx-auto" /><p className="mt-6 text-ink-soft">Confirming your payment…</p></>)}
      {status === "paid" && (
        <>
          <CheckCircle2 className="text-success mx-auto" size={64} />
          <h1 className="font-heading font-black text-3xl text-ink mt-5">Welcome to Premium!</h1>
          <p className="text-ink-soft mt-2">All purchase links are unlocked. Time to dress the family.</p>
          <button onClick={() => navigate("/family-deals")} data-testid="success-continue-btn" className="mt-6 h-14 px-8 rounded-full bg-brand text-white font-bold text-lg hover:bg-brand-hover transition-all shadow-md flex items-center gap-2 mx-auto"><Crown size={20} /> Start matching</button>
        </>
      )}
      {status === "error" && (
        <>
          <XCircle className="text-brand mx-auto" size={64} />
          <h1 className="font-heading font-black text-3xl text-ink mt-5">Couldn't confirm payment</h1>
          <p className="text-ink-soft mt-2">If you were charged, your membership will activate shortly.</p>
          <button onClick={() => navigate("/upgrade")} className="mt-6 h-14 px-8 rounded-full bg-brand text-white font-bold text-lg hover:bg-brand-hover transition-all shadow-md">Back to plans</button>
        </>
      )}
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="max-w-md mx-auto text-center py-20 fade-up">
      <XCircle className="text-ink-muted mx-auto" size={64} />
      <h1 className="font-heading font-black text-3xl text-ink mt-5">Checkout canceled</h1>
      <p className="text-ink-soft mt-2">No worries — you can upgrade anytime.</p>
      <button onClick={() => navigate("/upgrade")} data-testid="cancel-back-btn" className="mt-6 h-14 px-8 rounded-full bg-brand text-white font-bold text-lg hover:bg-brand-hover transition-all shadow-md">Back to plans</button>
    </div>
  );
}
